<template>
  <div
    style="display: flex"
    class="fixed overflow-auto w-full h-full flex justify-center items-center top-0 right-0 bg-slate-300"
  >
    <v-row class="bg-slate-500 flex max-w-[80%] rounded-lg">
      <v-col
      cols="12"
        md="6"
        lg="4"
        v-if="loginUser"
        class="shadow-2xl"
        style="background-color: #ffffff"
      >
        <div class="imageMobile">
          <img
            src="../../assets/loginMobile.jpg"
            style="width: 100%; height: 95%"
          />
        </div>
        <v-container class="bg-white" style="margin-top: 50px">
          <!-- <v-col>
            <img class=" max-w-[200px]" src="../../assets/bargram.png"/>
          </v-col> -->
          <v-col>
            <span style="font-size: 22px">به بارگرام خوش آمدید!</span>
          </v-col>
          <v-col>
            <span style="font-size: 18px"
              >ورود به حساب کاربری /
              <router-link to="/auth/register" class="text-sm"
                >ثبت نام</router-link
              >
            </span>
            <span class="text-sm text-red-300 block mt-2"
              >(این پنل مخصوص صاحب کالا و شرکت های حمل و نقل میباشد)</span
            >
          </v-col>
          <div  >
            <v-col class="pb-0">
              <span style="font-size: 14px; color: #6c7f96">شماره تلفن</span>
            </v-col>
            <v-col class="mb-0 pb-0">
              <v-text-field
                class="custom-input inputLogin !w-[100%]"
                v-model="mobile"
                outlined
                counter="11"
                :error-messages="errors?.mobile"
                :disabled="otpInput"
              ></v-text-field>
            </v-col>

            <div v-if="otpInput" class="mb-20">
              <v-col>
                <span style="font-size: 14px; color: #6c7f96"
                  >کد را وارد کنید :
                </span>
              </v-col>
              <v-col>
                <template>
                  <div class="ma-auto" style="max-width: 260px">
                    <v-otp-input
                      style="direction: ltr"
                      v-model="otp"
                      length="5"
                    ></v-otp-input>
                  </div>
                </template>
              </v-col>
              <div class="flex space-x-3 justify-center">
                <!-- <g-recaptcha 
              data-sitekey="6LeQCbsoAAAAAPjBvHvAtb5OqVtg7AzBav4YrF5K" 
              :data-validate="validate"
              :data-callback="callback"
            > -->
                <v-btn
                  class="primary"
                  style="border-radius: 8px; min-width: 95px !important"
                  :loading="loading"
                  :disabled="loading"
                  @click="callback"
                >
                  <span> ورود </span>
                </v-btn>
                <!-- </g-recaptcha> -->
                <v-btn
                  style="
                    border-radius: 8px;
                    min-width: 105px !important;
                    background-color: #f0f3f8 !important;
                    margin-right: 10px;
                  "
                  :loading="loading"
                  :disabled="loading"
                  @click="
                    (mobileInput = true),
                      (passwordInput = false),
                      (otpInput = false)
                  "
                >
                  <span> برگشت </span>
                </v-btn>
              </div>
            </div>
            <div v-if="!otpInput" class="mb-20">
              <v-col class="py-0">
                <span style="font-size: 14px; color: #6c7f96">کلمه عبور</span>
              </v-col>
              <v-col>
                <div class="flex relative">
                  <v-text-field
                    @keyup.enter="callback"
                    class="custom-input inputLogin"
                    v-model="password"
                    outlined
                    :error-messages="errors?.password"
                    :type="inputType"
                    chips
                    small-chips
                  >
                  </v-text-field>
                  <VBtn
                    class="absolute left-2 top-3"
                    variant="text"
                    color="primary"
                    size="small"
                    @click="
                      inputType = inputType === 'password' ? 'text' : 'password'
                    "
                    icon
                  >
                    <VIcon>{{
                      inputType === "password" ? "mdi-eye" : "mdi-eye-off"
                    }}</VIcon>
                  </VBtn>
                </div>
                <div>
                  <span style="font-size: 12px; color: #6c7f96"
                    >کلمه عبور را فراموش کردید؟
                  </span>
                  <span
                    class="cursor-pointer"
                    style="font-size: 12px; color: #396aff"
                    @click="
                      loginUser = false;
                      forget = true;
                    "
                    >بازنشانی کلمه عبور
                  </span>
                </div>
              </v-col>
              <!-- product -->
              <v-col>
                <!-- <g-recaptcha 
              data-sitekey="6LeQCbsoAAAAAPjBvHvAtb5OqVtg7AzBav4YrF5K" 
              :data-validate="validate"
              :data-callback="callback"
            > -->
                <v-btn
                  class="primary block w-[100%]"
                  style="border-radius: 8px; min-width: 95px !important"
                  :loading="loading"
                  :disabled="loading"
                  @click="callback"
                >
                  <span> ورود </span>
                </v-btn>

                <v-btn
                  class="block w-[100%] mt-2"
                  style="border-radius: 8px; min-width: 95px !important"
                  :loading="loading"
                  :disabled="loading || isBot || !mobile"
                  @click="
                    sendSms('send'),
                      (mobileInput = false),
                      (passwordInput = false),
                      (otpInput = true)
                  "
                >
                  <span class="text-sm"> ورود با کد یک بار مصرف </span>
                </v-btn>
                <!-- </g-recaptcha> -->
                <!-- <v-btn
                style="border-radius: 23px;min-width: 105px!important;background-color: #F0F3F8!important;margin-right: 10px"
                :loading="loading"
                :disabled="loading"
                @click="mobileInput = true , passwordInput = false , otpInput = false"
            >
              <span>
                برگشت
              </span>
            </v-btn> -->
              </v-col>

              <!-- test -->
              <!-- <div class="flex space-x-3">
              <v-btn
                  class="primary"
                  @click="login"
                  style="border-radius: 23px;min-width: 95px!important;"
                  :loading="loading"
                  :disabled="loading"
              >
                <span>
                  ورود بدون فلان
                </span>
              </v-btn>
            </div> -->
            </div>
          </div>
        </v-container>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
         v-if="forget"
        class="  "
        style="background-color: #ffffff"
      >
      <v-container class="bg-white" style="margin-top: 50px">
      
      
          <v-col>
            <span style="font-size: 18px">تغییر کلمه عبور</span>
          </v-col>
          <v-col>
          
              <v-text-field v-model="mobile" label="تلفن همراه" type="tel" class="text-center"  outlined ></v-text-field>
            
          </v-col>
          <v-col class="flex justify-between">
            <v-btn
              class="w-[48%] primary"
              style="min-width: 95px !important"
              :loading="loading"
              :disabled="loading"
              @click="sendSms()"
            >
              <span> ادامه </span>
            </v-btn>
            <v-btn
              class="w-[48%]"
              style="
                min-width: 105px !important;
                background-color: #f0f3f8 !important;
              "
              :loading="loading"
              :disabled="loading"
              @click="
                forget = false;
                loginUser = true;
              "
            >
              <span> برگشت </span>
            </v-btn>
          </v-col>
       </v-container>
      </v-col>
      <v-col
      cols="12"
        md="6"
        lg="4"
        v-if="confirm"
        class="resizeForm"
        style="background-color: #ffffff"
      >
        <div style="margin: auto; width: 100%; margin-top: 60px">
          <v-col>
            <span style="font-size: 18px">تایید شماره تلفن</span>
          </v-col>
          <v-col>
            <v-col>
              <span style="font-size: 14px; color: #6c7f96"
                >کد ارسال شده به شماره {{ mobile }} را وارد کنید</span
              >
            </v-col>
            <v-col>
              <input v-model="code" type="tel" class="input" />
            </v-col>
            <v-col>
              <span style="font-size: 14px; color: #6c7f96">پسورد</span>
            </v-col>
            <v-col>
              <input v-model="password" type="password" class="input" />
            </v-col>
            <v-col>
              <span style="font-size: 14px; color: #6c7f96">تکرار پسورد</span>
            </v-col>
            <v-col>
              <input v-model="passwordConfirm" type="password" class="input" />
            </v-col>
          </v-col>
          <v-col>
            <v-btn
              class="primary"
              style="border-radius: 23px; min-width: 95px !important"
              :loading="loading"
              :disabled="loading"
              @click="forgetPassword()"
            >
              <span> تایید </span>
            </v-btn>
            <v-btn
              style="
                border-radius: 23px;
                min-width: 105px !important;
                background-color: #f0f3f8 !important;
                margin-right: 10px;
              "
              :loading="loading"
              :disabled="loading"
              @click="
                forget = false;
                loginUser = true;
                confirm = false;
              "
            >
              <span> برگشت </span>
            </v-btn>
          </v-col>
        </div>
      </v-col>

      <v-col
      cols="12"
        md="6"
        lg="8"
        class="resize hidden md:flex"
        style="background-color: rgba(250, 248, 253, 1)"
      >
        <img src="../../assets/login2.png" class="centerImage" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import gRecaptcha from '@finpo/vue2-recaptcha-invisible';

import axiosApi from "@/plugins/axios";
import Vue from "vue";
export default {
  name: "Login",
  // components: { gRecaptcha },
  data() {
    return {
      isBot: false,
      siteKey: "6LeQCbsoAAAAAPjBvHvAtb5OqVtg7AzBav4YrF5K",
      mobile: "",
      role: "",
      roles: [],
      errors: [],
      loginUser: true,
      forget: false,
      mobileInput: true,
      otpInput: false,
      passwordInput: false,
      verify: null,
      disableMobile: false,
      otp: null,
      inputType: "password",
      code: "",
      passwordConfirm: "",
      confirm: false,
      password: null,
      loading: false,
    };
  },
  methods: {
    validate() {
      return true;
    },
    callback() {
      // if (token) {
      this.login();
      // } else {
      //   console.log('nooo');
      // }
    },
    forgetPassword() {
      if (this.password === this.passwordConfirm) {
        this.loading = true;
        axiosApi()
          .post("v2/token/forgetPassword", {
            mobile: this.mobile,
            password: this.password,
            otp: this.code,
          })
          .then(() => {
            Vue.$toast.open({
              message: "پسورد با موفقیت تغییر یافت.",
              type: "success",
            });
            this.confirm = false;
            this.forget = false;
            this.loginUser = true;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        Vue.$toast.open({
          message: "لطفا پسورد ها را با دقت بیشتر و یکسان وارد کنید",
          type: "error",
        });
      }
    },
    sendSms(type = null) {
      this.loading = true;
      axiosApi()
        .post("v2/token/reSendCode", {
          mobile: this.mobile,
          type: "LOGIN",
        })
        .then(() => {
          if (type == null) {
            this.forget = false;
            this.confirm = true;
          }
          this.loading = false;
          Vue.$toast.open({
            message: "کد برای شما ارسال شد",
            type: "success",
          });
        })
        .catch((e) => {
          this.loading = false;
          if (type == null && e.response.status === 402) {
            this.forget = false;
            this.loginUser = false;
            this.confirm = true;
          }
          Vue.$toast.open({
            message: e.response.data.error,
            type: "warning",
          });
        });
    },
    setMainRole(roles) {
      const defaultRoles = [
        "FACTORY",
        "FACTORY_MEMBER",
        "COMPANY",
        "COMPANY_MEMBER",
      ];
      let iRole = null;
      roles.forEach((role) => {
        if (!defaultRoles.includes(role)) return;
        iRole = role;
      });
      return iRole;
    },
    login() {
      this.loading = true;
      if (this.otpInput) {
        this.password = null;
      } else {
        this.otp = null;
      }
      axiosApi()
        .post("v2/token/logins", {
          mobile: this.mobile,
          password: this.password,
          otp: this.otp,
        })
        .then((result) => {
          Vue.$toast.open({
            message: "خوش آمدید",
            type: "success",
          });

          this.roles = result.data.data.roles.map((role) => role.name);
          if (result.data.data.isAdmin) {
            this.role = "ADMIN";
          } else {
            this.role = this.setMainRole(this.roles);
          }

          localStorage.setItem("role", this.role);
          localStorage.setItem("mobile", this.mobile);
          
          if(localStorage.getItem("mobile") === '09196769045') {
            localStorage.setItem("customUser" , '09196769045');
          }
          if (result.data.data.isAdmin) {
            localStorage.setItem(
              "permissions",
              JSON.stringify(result.data.data.permissions)
            );
            localStorage.setItem(
              "nickname",
              JSON.stringify(result.data.data.user.nickname)
            );
          }
          if (this.role === "FACTORY") {
            localStorage.setItem("type", result.data.data.user.type);
            let name = "";
            if (result.data.data.user.factory_user) {
              name =
                result.data.data.user?.factory_user.factoryName != null
                  ? result.data.data.user?.factory_user.factoryName
                  : result.data.data.user?.factory_user.managerName +
                    " " +
                    result.data.data.user?.factory_user.managerFamily;
            }
            localStorage.setItem("name", name);
          }
          if (this.role === "FACTORY_MEMBER") {
            localStorage.setItem(
              "permissions",
              JSON.stringify(result.data.data.permissions)
            );
            localStorage.setItem("type", result.data.data.user.type);
            let name = "";
            if (result.data.data.user.factory_user) {
              name =
                result.data.data.user?.factory_user.factoryName != null
                  ? result.data.data.user?.factory_user.factoryName
                  : result.data.data.user?.factory_user.managerName +
                    " " +
                    result.data.data.user?.factory_user.managerFamily;
            }
            localStorage.setItem("name", name);
          }
          if (this.role === "COMPANY" || this.role === "COMPANY_MEMBER") {
            localStorage.setItem("name", result.data.data.company_name);
          }
          localStorage.setItem("token", result.data.data.access_token);
          this.$parent.login = true;
          location.replace("/");
        })
        .catch((e) => {
          this.loading = false;
          this.errors = e.response?.data?.errors
            ? e.response?.data?.errors
            : e.response?.data?.error;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.resize {
  width: 50%;
}

.resizeForm {
}

.centerImage {
  display: block;
  margin: auto;
  width: 65%;
  position: sticky;
  top: 10%;
}

.input {
  text-align: center;
  box-sizing: border-box;
  max-width: 350px;
  width: 100%;
  height: 49px;
  left: 232px;
  top: 320px;
  opacity: 0.5;
  border: 1px solid #9cb1ca;
  border-radius: 8px;
}

.imageMobile {
  display: none;
}

@media only screen and (max-width: 780px) {
  .resize {
    display: none;
    width: 40%;
  }

  .resizeForm {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
}

@media only screen and (max-width: 600px) {
  .resize {
    display: none;
    width: 0;
  }

  .imageMobile {
    display: block;
    height: 150px;
  }

  .resizeForm {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
}

.inputLogin {
  width: 100%;
  opacity: 0.8;
  border-radius: 8px;
  width: 350px;
}

.v-text-field input {
  text-align: center !important;
}

.v-input input {
  text-align: center !important;
}

.centered-input input {
  text-align: center;
}
</style>
